import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import {
  IconButton,
  Toolbar,
  TableContainer,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Paper,
  Grid,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import { Table } from "react-bootstrap";
import {
  getPurchaseRequestsByProject
} from "../../../../services/project_service";

import "./Details_projects.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: 16,
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  input: {
    display: "none",
  },
}));

function get_direction_title(id,directions) {
  // //  console.log("suppli")
  let dir_title = null;
  for (let dir of directions) {
    if (dir.id == id) { dir_title = dir.title; break; }
  }
  return dir_title;
}

function Project_detail({ title, details, directions }) {
  return (
    <div className="project_details_container">
      <h3 className="section-title">{title}</h3>

      <div className="project_form_details_container">
        <div className="project_form_infos_container">
          <Row className="mb-12">
            <Form.Group className="col-6">
              <label className="label-fonce">Titre du projet :</label>
              <Form.Control
                required
                autoComplete
                type="text"
                placeholder="Titre du projet *"
                value={details.title}
                readOnly
              />
            </Form.Group>
            <Form.Group className="col-6">
              <label className="label-fonce">Direction :</label>
              <Form.Control
                required
                autoComplete
                type="text"
                placeholder="Direction *"
                value={get_direction_title(details.direction,directions)}
                readOnly
              />
            </Form.Group>
            <Form.Group className="col-6">
              <label className="label-fonce">Chef du projet :</label>
              <Form.Control
                required
                autoComplete
                type="text"
                placeholder="Chef du projet *"
                value={details.project_manager}
                readOnly
              />
            </Form.Group>
            <Form.Group className="col-6">
              <label className="label-fonce">Budget estimatif (MAD) :</label>
              <Form.Control
                required
                autoComplete
                type="text"
                placeholder="Budget estimatif *"
                value={details.estimated_budget}
                readOnly
              />
            </Form.Group>
            <Form.Group className="col-6">
              <label className="label-fonce">Date du début :</label>
              <Form.Control
                required
                autoComplete
                type="text"
                placeholder="Date du début *"
                value={(new Date(details.start_date)).toLocaleDateString()}
                readOnly
              />
            </Form.Group>
            <Form.Group className="col-6">
              <label className="label-fonce">Date de fin :</label>
              <Form.Control
                required
                autoComplete
                type="text"
                placeholder="Date de fin *"
                value={(new Date(details.end_date)).toLocaleDateString()}
                readOnly
              />
            </Form.Group>
          </Row>
          <Row className="mb-12">
            <Form.Group className="col-6">
              <label className="label-fonce">Description :</label>
              <Form.Control
                required
                autoComplete
                as="textarea"
                rows={6}
                placeholder="Description *"
                value={details.description}
                readOnly
              />
            </Form.Group>
          </Row>
        </div>
      </div>
    </div>
  );
}

function Project_detail_purchase({ projectCode }) {
  const [purchases, setPurchases] = useState([]);

  useEffect(() => {
    const fetchPurchases = async () => {
      try {
        const response = await getPurchaseRequestsByProject(projectCode);
       //  console.log('Données reçues:', response.data);
        setPurchases(response.data);
      } catch (error) {
        console.error("Erreur lors du chargement des demandes d'achat", error);
      }
    };

    if (projectCode) {
      fetchPurchases();
    }
  }, [projectCode]);

  return (
    <div className="project_details_container">
      <h3 className="section-title">Liste des demandes d'achats :</h3>

      <Grid item xs={12} sx={{ marginTop: "30px" }}>
        <TableContainer
          component={Paper}
          elevation={4}
          sx={{
            overflowX: "auto",
            borderRadius: 3,
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
          }}
        >
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                <TableCell>
                  <strong>Code de la demande</strong>
                </TableCell>
                <TableCell>
                  <strong>Demandeur</strong>
                </TableCell>
                <TableCell>
                  <strong>Imputation</strong>
                </TableCell>
                <TableCell>
                  <strong>Status</strong>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {purchases.length > 0 ? (
                purchases.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.request_code}</TableCell>
                    <TableCell>
                      {item.requester_firstName + " " + item.requester_lastName}
                    </TableCell>
                    <TableCell>{item.object}</TableCell>
                    <TableCell>{state(item.request_state)}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    Aucune demande d'achat n'est trouvée pour ce projet.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </div>
  );
}

function Budget({ project }) {
  
  return (
    <div className="project_details_container">
      <h3 className="section-title">État budgétaire :</h3>

      {/* Résumé global du budget */}
      <div className="mb-4">
        <div className="row text-center">
          <div className="col-md-3">
            <div className="p-3 bg-light rounded shadow-sm">
              <p className="mb-1 text-muted">Budget estimatif</p>
              <h5 className="text-primary">{project.estimated_budget} MAD</h5>
            </div>
          </div>
          <div className="col-md-3">
            <div className="p-3 bg-light rounded shadow-sm">
              <p className="mb-1 text-muted">Budget engagé</p>
              <h5 className="text-warning">
              {project.committed_budget??0} MAD
              </h5>
            </div>
          </div>
          <div className="col-md-3">
            <div className="p-3 bg-light rounded shadow-sm">
              <p className="mb-1 text-muted">Budget réalisé</p>
              <h5 className="text-success">
              {project.realized_budget??0} MAD
              </h5>
            </div>
          </div>
          <div className="col-md-3">
          <div className="p-3 bg-light rounded shadow-sm">
            <p className="mb-1 text-muted">Budget restant</p>
            <h5 className="text-info">
              {(project.estimated_budget - (project.committed_budget??0)).toFixed(2)} MAD
            </h5>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
}

function state(request_state) {
  return (
    <>
      {request_state === null ||
      request_state === "demander à être changée" ||
      request_state === "en cours de traitement" ||
      request_state === "En cours de livraison (interne)" ? (
        <Button variant="contained" className="status_waiting">
          {request_state ? request_state : "En cours"}
        </Button>
      ) : request_state === "refusée" ||
        request_state === "annulée" ||
        request_state === "refus de traitement" ||
        request_state === "non conforme" ||
        request_state === "Non conforme (interne)" ? (
        <Button variant="contained" className="status_deny">
          {request_state}
        </Button>
      ) : (
        <Button variant="contained" className="status_success">
          {request_state}
        </Button>
      )}
    </>
  );
}

function Details_projects({ project, onClose, directions }) {
  const classes = useStyles();

  if (!project) return null; // sécurité au cas où

  return (
    <Dialog
      fullScreen
      open={true}
      onClose={onClose}
      className="my_full_dialog contract_full_dialog"
    >
      <AppBar className={classes.appBar}>
        <Toolbar style={{ backgroundColor: "#343a40" }}>
          <div className="request_order_toolbar_main_container">
            <div className="request_order_toolbar_left page_title">
              <IconButton
                edge="start"
                color="inherit"
                onClick={onClose}
                aria-label="close"
              >
                <CloseIcon className="my_icon" />
              </IconButton>
              <span> Details du projet : {project.project_code} </span>
            </div>
          </div>
        </Toolbar>
      </AppBar>
      <div className="Details_container request_details_container">
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <Budget project={project} />
          <Project_detail title="Détails du projet :" details={project} directions={directions} />

          <Project_detail_purchase
            projectCode={project.project_code}
          />
        </div>
      </div>
    </Dialog>
  );
}

export default Details_projects;
